<app-stages [stages]="stages" currentStage="Lokalizacja">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete='off' novalidate [formGroup]='form' (ngSubmit)='submitAndGoNext()'>
    <fieldset>
      <legend>
        Działki
      </legend>
      <app-parcels-crud tag="parcels" formControlName="parcels">
      </app-parcels-crud>
    </fieldset>
    <fieldset>
      <legend>
        Dodatkowe informacje
      </legend>
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"description" as controlName'>
            <label [for]='controlName'>
              Opis
            </label>
            <textarea
              rows="8"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu szczegóły dostępu do drogi publicznej'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
  <div class='application-actions'>
    <button
      [disabled]="pending()"
      (click)="onCancel()"
      type='button'
      class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
    </button>
    <button
      (click)="submitAndGoNext()"
      [disabled]="pending()"
      type='button'
      class='btn btn-primary'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywanie danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
